import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";
import {
  ICatNuevoAcuerdoMrb,
  ICMoverDespacho,
} from "../../interfaces/catalogos.";
import { selectNuevoAcuerdo } from "../acuerdos-mrb/selector";
import { environment } from "../../../environments/environment";

export const selectCatalogosState = (state: AppState) => state.catalogos;

export const selectCatalogos = createSelector(
  selectCatalogosState,
  (state) => state
);
export const selectCatalogosEmpresa = createSelector(
  selectCatalogosState,
  (state) => state.catEmpresa
);

export const selectCatalogoTipoTemas = createSelector(
  selectCatalogosState,
  (state) => state.catTipoTemas
);

export const selectCatalogoCategorizacion = createSelector(
  selectCatalogosState,
  (state) => state.catCategorizacion
);

export const selectCatalogoTipoDespacho = createSelector(
  selectCatalogosState,
  (state) => state.catTipoDespacho
);

export const selectCatalogosMoverMrb = createSelector(
  selectCatalogosState,
  (state) => {
    const catEmpresa = state.catEmpresa.filter((empresa) => empresa.activo);
    catEmpresa.push({ activo: true, descripcion: "Otro", id: "Otro" });
    const catFormaEnvio = state.catFormaEnvio.filter((forma) => forma.id != 1);
    const catalogos: ICMoverDespacho = {
      catEmpresa,
      catTipoDespacho: state.catTipoDespacho ?? [],
      catFormaEnvio,
    };
    return catalogos as ICMoverDespacho;
  }
);

export const selectCatalogoEmpresas = createSelector(
  selectCatalogosState,
  (state) => {
    const empresas = state.catEmpresa || [];

    return empresas
      .filter((empresa) => empresa.activo)
      .map(({ id, descripcion }) => ({
        descripcion: descripcion,
        id: id,
        id_empresa: id,
      }));
  }
);
export const selectEmpresaById = (idEmpresa: string) =>
  createSelector(selectCatalogosEmpresa, (state) => {
    return state.find((empresa) => empresa.id === idEmpresa);
  });

// Selector combinado
export const selectCatalogosNuevoAcuerdo = createSelector(
  selectCatalogosState,
  selectNuevoAcuerdo,
  (cats, { responsables }) => {
    let { analista, supervisor, coordinador } = structuredClone(responsables);

    //DUPLICAMOS USUARIO SUPERVISOR EN ESPECIFICO
    let usuarioClone = supervisor.filter(item => (item.idFB == environment.user_supervisor && item.idRol == 2));
    if(usuarioClone.length == 1) {
      let usuarioCoordinador = structuredClone(usuarioClone[0]);
      usuarioCoordinador.idRol = 3;
      coordinador.push(usuarioCoordinador);
    }

    const catalogos: ICatNuevoAcuerdoMrb = {
      catTipoTema: cats.catTipoTemas ?? [],
      catCategorizacion: cats.catCategorizacion ?? [],
      catCategoria: cats.catCategoria ?? [],
      catAnalista: filtrarResponsables(analista),
      catSupervisor: filtrarResponsables(supervisor),
      catCoordinador: filtrarResponsables(coordinador),
    };
    return catalogos as ICatNuevoAcuerdoMrb;
  }
);

const filtrarResponsables = (responsables: any) => {
  return responsables.filter((res: any) => res.mostrar && res.banEsActivo);
};
